import { createStore, applyMiddleware, combineReducers, type AnyAction } from 'redux';
import { thunk, type ThunkDispatch } from 'redux-thunk';
import principalReducer from './principalReducer';
import programReducer from './programReducer';
import tenantReducer from './tenantReducer';
import vpaReducer from './vpaReducer';

const rootReducer = combineReducers({
  principal: principalReducer,
  program: programReducer,
  tenant: tenantReducer,
  vpa: vpaReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const store = createStore(rootReducer, applyMiddleware(thunk as any));

export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export default store;

